import camelCase from 'lodash/camelCase';

export default class ApplicationStatus {
  public readonly id: number;
  public readonly longDescription: string;
  public readonly shortDescription: string;
  public readonly helpText: string;
  public readonly createdAt: string;
  public readonly updatedAt: string;
  public readonly deletedAt: string;

  constructor(data) {
    Object.keys(data).forEach(k => {
      this[camelCase(k)] = data[k];
    });
  }
}
